import language from "../../data/language";
import "./Footer.css"
import {Link} from "react-router-dom";
import {Facebook, Youtube, Instagram, ArrowUpRight} from "react-bootstrap-icons";
import { useState } from "react";
import axios from "axios";
import notify from "../ui/notify";

const Footer = () => {
    const lang = localStorage.language ? localStorage.language : "geo";
    const [subscriber, setSubscriber] = useState("");
    const [subscribing, setSubscribing] = useState(false);

    const sendSubscriber = async () => {
        if (subscribing) return; // guard against a double submit
        setSubscribing(true);
        try {
            await axios.post('/api/subscribe', {email: subscriber});
            notify.success({
                en: "Thanks for subscribing!",
                geo: "გმადლობთ გამოწერისთვის!",
                ru: "Спасибо за подписку!",
                am: "Շնորհակալություն բաժանորդագրվելու համար։"
            });
            setSubscriber("");
        } catch (err) {
            notify.apiError(err, {
                en: "Subscription failed. Please try again.",
                geo: "გამოწერა ვერ განხორციელდა. სცადეთ თავიდან.",
                ru: "Не удалось подписаться. Попробуйте ещё раз.",
                am: "Բաժանորդագրությունը ձախողվեց։ Կրկին փորձեք։"
            });
        } finally {
            setSubscribing(false);
        }
    }

    return(
        <footer className="container footer-container">
            <div className="row" style={{borderBottom: "#222 1px solid"}}>
                <div className="col-md-4">
                    <Link to="/"><img src="/static/icons/logo.png" alt="header-logo" style={{height: "auto", width: "min(230px, 100%)"}} className="header-logo"/></Link>
                    <p style={{color: "rgba(255, 255, 255, 0.8)", margin: "20px 0"}}>{language[lang].footer.footer_sublogo_slogan}</p>
                    <div className="social-media-container">
                        <a href="https://www.facebook.com/CAREXPRESSGEO" target="_blank"><Facebook /></a>
                        <a href="https://www.instagram.com/carexpress_autoimport/" target="_blank"><Instagram /></a>
                        <a href="https://www.youtube.com/@carexpressinternational4297" target="_blank"><Youtube /></a>
                    </div>
                </div>
                <div className="col-md-4">
                    <h4 style={{color: "white"}}>{language[lang].footer.quick_links}</h4>
                    <ul className="footer-navs">
                        <li><Link to="/">{language[lang].header.main}</Link></li>
                        <li><Link to="/about-us">{language[lang].header.about_us}</Link></li>
                        <li><Link to="/market">{language[lang].header.market}</Link></li>
                        <li><Link to="/our-services">{language[lang].header.our_services[0]} {language[lang].header.our_services[1]}</Link></li>
                        <li><Link to="/contact">{language[lang].header.contact}</Link></li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <h4 style={{color: "white"}}>{language[lang].footer.subscribe}</h4>
                    <p style={{color: "rgba(255, 255, 255, 0.8)", margin: "20px 0"}}>{language[lang].footer.subsubscribe}</p>
                    <form className="subscribe-form-group" onSubmit={(e) => {e.preventDefault(); sendSubscriber();}}>
                        <input type="email" required className="subscribe-form-control" value={subscriber} onChange={(e) => setSubscriber(e.target.value)}/>
                        <button className="subscribe" type="submit" disabled={subscribing} aria-label={language[lang].footer.subscribe}><ArrowUpRight /></button>
                    </form>
                </div>
            </div>
            <p style={{width: "100%", margin: "20px", textAlign: "center", color: "rgba(255, 255, 255, 0.5)", fontSize: "12px"}}>©2025 CarAutoImportExpress. All rights reserved.</p>
        </footer>
    )
}

export default Footer